var REQUEST_TOKEN;
(function (REQUEST_TOKEN) {
    REQUEST_TOKEN[REQUEST_TOKEN["ANONYMOUS"] = 0] = "ANONYMOUS";
    REQUEST_TOKEN[REQUEST_TOKEN["OPTIONAL"] = 1] = "OPTIONAL";
    REQUEST_TOKEN[REQUEST_TOKEN["SECURE"] = 2] = "SECURE";
})(REQUEST_TOKEN || (REQUEST_TOKEN = {}));
var ROLE;
(function (ROLE) {
    ROLE[ROLE["ANONYMOUS"] = 0] = "ANONYMOUS";
    ROLE[ROLE["USER"] = 1] = "USER";
})(ROLE || (ROLE = {}));
const SECURE_CONFIG_PARAM_VARIANTS = [REQUEST_TOKEN.OPTIONAL, REQUEST_TOKEN.SECURE];
export { REQUEST_TOKEN, ROLE, SECURE_CONFIG_PARAM_VARIANTS };
//# sourceMappingURL=auth.js.map